/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Resourcesrolesdescription2Inputs */

const en_settings_resourcesrolesdescription2 = /** @type {(inputs: Settings_Resourcesrolesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get an overview of how roles control user access`)
};

/**
* | output |
* | --- |
* | "Get an overview of how roles control user access" |
*
* @param {Settings_Resourcesrolesdescription2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_resourcesrolesdescription2 = /** @type {((inputs?: Settings_Resourcesrolesdescription2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Resourcesrolesdescription2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_resourcesrolesdescription2(inputs)
});
export { settings_resourcesrolesdescription2 as "settings_resourcesRolesDescription" }